import { capitalCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@material-ui/core/styles';
import { Box, Card, Stack, Link, Alert, Tooltip, Container, Typography, Button, Divider } from '@material-ui/core';
// routes
//  import { PATH_AUTH } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
// layouts
import AuthLayout from '../../layouts/AuthLayout';
// components
import Page from '../../components/Page';
import { MHidden } from '../../components/@material-extend';
import { LoginForm } from '../../components/authentication/login';
import AuthFirebaseSocials from '../../components/authentication/AuthFirebaseSocial';
import { motion } from 'framer-motion';
import { varFadeIn, varFadeInUp, varWrapEnter, varFadeInRight } from '../../components/animate';
// ----------------------------------------------------------------------


const RootStyle = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  //backgroundColor: theme.palette.grey[400],
  height: '100%',
  [theme.breakpoints.up('md')]: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
    display: 'flex',
    position: 'fixed',
    alignItems: 'center'
  }
}));
const HeroImgStyle = styled(motion.img)(({ theme }) => ({
  top: 0,
  right: 0,
  bottom: 0,
  zIndex: 8,
  width: '100%',
  margin: 'auto',
  position: 'absolute',
  [theme.breakpoints.up('lg')]: {
    right: '8%',
    width: 'auto',
    height: '48vh'
  }
}));
const SectionStyle = styled('div')(({ theme }) => ({
  width: '35%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  // justifyContent: 'center',
  margin: theme.spacing(0, 0, 0, 7),
  padding: theme.spacing(0, 0, 0, 0),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: theme.spacing(16, 7, 0, 0),
  }
}));
// const ImageStyle = styled('div')(({ theme }) => ({

const SectionFooterStyle = styled('div')(({ theme }) => ({
  maxWidth: 474,
  display: 'flex',
  padding: 2,
  marginLeft: '3em',
  marginBottom:-50,
  // justifyContent: 'center',

}));


//   [theme.breakpoints.up('md')]: {
//     height: 560,
//     padding: 0
//   }
// }));
const ContentStyle = styled('div')(({ theme }) => ({
  width: "100%",
  zIndex: 10,
  height: '80%',
  //margin: 'auto',
  // backgroundSize: '100% 100%',
  // backgroundPosition: 'center',
  // backgroundImage: 'url(/static/auth/background.png)',
  // padding: theme.spacing(10, 0),
  display: 'flex',
  //minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'start',

}));
const HeroOverlayStyle = styled(motion.img)({
  zIndex: 9,
  width: '100%',
  height: '100%',
  objectFit: 'fill',
  position: 'absolute'
});
// ----------------------------------------------------------------------

export default function Login() {
  const { method, login } = useAuth();
  const handleLoginAuth0 = async () => {
    try {
      await login();
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <RootStyle title="ĐĂNG NHẬP | ĐA KÊNH VOIP24H">
      {/* <Container maxWidth="lg"> */}
      <MHidden width='mdDown'>
        <HeroOverlayStyle alt="overlay" src="/static/auth/dashboard_login.png" variants={varFadeIn} />
      </MHidden>
      
      <ContentStyle>
        <AuthLayout>
          <Stack direction={"row"}>
            <Typography color={"white"}>Bạn chưa có tài khoản? </Typography>
            {/* <Link underline="none" variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}> */}
            <Link target="_blank" underline="none" variant="subtitle2" href="https://www.busscall.vn/">
              Truy cập
            </Link>
          </Stack>

        </AuthLayout>
        <Stack direction={"row"} sx={{ width: "100%", height: "100%" }}>
          <SectionStyle>
            <Typography variant="h3" sx={{ mt: { xl: "30px", lg: "40px", md: "50px" }, color: "#303187", fontSize: { xl: "3rem", lg: "2.2rem", md: "2rem", xs: '1.3rem' } }}>
              CHÀO MỪNG ĐẾN VỚI <br /> DỊCH VỤ  ĐA KÊNH
            </Typography>
            <Divider sx={{ width: { xl: "34%", lg: "29%", md: "39%" }, borderColor: "#EE4036", borderBottomWidth: "6px" }} />
            <Stack direction="row" alignItems="center" sx={{ mb: 2, mx: 0, mt: 2 }}>
              <Box sx={{ flexGrow: 1 }}>
                {/* <Typography variant="h4" gutterBottom>
                    Dịch Vụ Đa Kênh
                  </Typography> */}

                <Typography sx={{ color: 'text.secondary', fontSize: { xs: "0.3rem", xl: "1.3rem", md: "0.7rem", xs: '0.6rem' } }}>An toàn - Bảo mật dữ liệu - Nâng cao hiệu suất làm việc <br /> Báo cáo chính xác và kịp thời</Typography>
              </Box>

              {/* <Tooltip title={capitalCase(method)}>
                  <Box component="img" src={`/static/auth/ic_${method}.png`} sx={{ width: 32, height: 32 }} />
                </Tooltip> */}
            </Stack>
            {method === 'firebase' && <AuthFirebaseSocials />}
            {/* <Alert severity="info" sx={{ mb: 3 }}>
            Use email : <strong>demo@minimals.cc</strong> / password :<strong>&nbsp;demo1234</strong>
          </Alert> */}
            {method !== 'auth0' ? (
              <LoginForm />
            ) : (
              <Button fullWidth size="large" type="submit" variant="contained" onClick={handleLoginAuth0}>
                {/* <Button fullWidth size="large" type="submit" variant="contained" > */}
                Đăng nhập
              </Button>
            )}
            <MHidden width="smUp">
              <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                Don’t have an account?&nbsp;
                {/* <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}> */}
                <Link variant="subtitle2" component={RouterLink} to="bcd">
                  Get started
                </Link>
              </Typography>
            </MHidden>
          </SectionStyle>
          {/* <ImageStyle >
            <Box component="img" src={`/static/auth/login.png`} sx={{ width: 128, height: 128 }} />
            
            </ImageStyle> */}
        </Stack>
        <MHidden width="lgDown">
          <SectionFooterStyle>
            <Box sx={{ mt: 4, height: "100%", width: "100%", display: 'flex', flexWrap: 2, flexDirection: "column" }}>
              <Stack direction={"row"} spacing={2}>
                <Box component="img" src={`/static/auth/icon/phone.png`} sx={{ width: 28, height: 28 }} />
                <Typography variant="h4" sx={{ color: "#303187" }}>1900 2002</Typography>
              </Stack>
              <Stack direction={"row"} spacing={2}>
                <Box component="img" src={`/static/auth/icon/share.png`} sx={{ width: 28, height: 28 }} />
                <Typography variant="h4" sx={{ color: "#303187" }}>dakenh.voip24h.vn</Typography>
              </Stack>


            </Box>
          </SectionFooterStyle>
        </MHidden>
        {/* <MHidden width="lgDown">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ height: "45px", width: '75%', float: "right", background: "#41c7f5", clipPath: 'polygon(0 0, 100% 0, 100% 100%, 5% 100%)' }}> </Box>
            <Box sx={{ height: "45px", width: '50%', background: "red", clipPath: 'polygon(0 0, 95% 0, 100% 100%, 0 100%)' }}> </Box>
          </Box>
        </MHidden> */}
      </ContentStyle>
      {/* </Container> */}
    </RootStyle>
  );
}
